export default __webpack_public_path__ + "static/media/nodiDefault.cd539a99.svg";